module.exports = __webpack_public_path__ + "img/ps.39ccbb8e.svg";